import { Fragment, useState, useEffect } from "react"
import { ChatActionButton as Button } from "@sui/chat-ui"
import { TextMessage } from "@/utils/message"
import "./index.less"

const parseString = (str) => {
  let titleRegex = /<chatbegin>(.*?)<\/chatbegin>/
  let contentRegex = /<chatmsg>(.*?)<\/chatmsg>/g
  let endRegex = /<chatend>(.*?)<\/chatend>/

  let titleMatch = str.match(titleRegex)
  let endMatch = str.match(endRegex)
  let contents = []
  let contentMatch

  while ((contentMatch = contentRegex.exec(str)) !== null) {
    contents.push(contentMatch[1])
  }

  return {
    title: titleMatch ? titleMatch[1] : "",
    end: endMatch ? endMatch[1] : "",
    content: contents,
  }
}



const ChatCard = (props) => {
  const { msg, chatInstance } = props
  const [chatData, setChatData] = useState({
    title: "",
    end: "",
    content: [],
  })

  const handleClick = (msg) => {
    const message = TextMessage(msg)
    chatInstance?.ctx?.postMessage?.(message)
  }

  useEffect(() => {
    if (msg.html) {
      const parseChat = parseString(msg.html)
      setChatData(parseChat)
    }
  }, [msg])

  if (!chatData.title || !chatData.content?.length || !chatData.end) {
    return null
  }

  return (
    <div className='card-chat'>
      {chatData.title ? <div className='card-chat_title'>{chatData.title}</div> : null}
      {chatData.content?.length || chatData.end ? <div className='card-chat_content'>
        {/* <span className="card-chat_content__begin">咨询</span> */}
        {chatData.content.map((text, index) => (
          <Fragment key={text}>
            {index !== 0 && <span className='card-chat_content__and'>或</span>}
            <Button variant='text' onClick={() => handleClick(text)}>
              {text}
            </Button>
          </Fragment>
        ))}
        <span className='card-chat_content__end'>{chatData.end}</span>
      </div> : null}
    </div>
  )
}

export default ChatCard
